<template>
  <SeoPage page-key="seoConsultingTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SeoConsultingTicinoPage'
})
</script>

